<template>
  <div class="home_page">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="create_order">
      <div class="order_body">
        <el-form ref="dataForm"
                 label-width="90px"
                 label-position="left">
          <el-row>
            <el-col :span="8">
              <el-form-item label="用户名：">{{$store.state.user.name}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单来源：">
                {{$getDictLabel("ORDER_SOURCE", params.orderSource)}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="采购公司：">{{dataJson && dataJson.companyName}}</el-form-item>
            </el-col>
          </el-row>
          <!-- 商品 -->
          <el-row>
            <el-col :span="24">
              <el-table :data="dataJson ? dataJson.payOrderItemVoList : []"
                        style="width: 100%"
                        border>
                <el-table-column align="center" prop="goodsCode" label="商品编号"></el-table-column>
                <el-table-column align="center" prop="goodsName" label="商品名称"></el-table-column>
                <el-table-column align="center" prop="brandName" label="品牌"></el-table-column>
                <el-table-column align="center" prop="goodsModel" label="型号" width="120"></el-table-column>
                <el-table-column align="center" prop="goodsNum" label="数量" width="70"></el-table-column>
                <el-table-column align="center" label="单价" width="130">
                  <template slot-scope="scope">
                    <span :label="scope.row.goodsPrice">{{scope.row.goodsPrice|formatePrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="总价" width="130">
                  <template slot-scope="scope">
                    <span :label="scope.row.money">{{scope.row.money|formatePrice}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 总金额 -->
              <el-row style="background-color:#ebebeb; height:50px">
                <el-col :span="5"
                        :offset="19"
                        style="margin-top:10px">
                  <span>总金额：<span style="color:red"><span>￥</span>{{(dataJson ? dataJson.payMoney : 0)|formatePrice}}</span></span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <!-- 合同模板 -->
          <el-row style="margin-top:20px">
            <el-col :span="12">
              <el-form-item label="订单合同：">
                宁东工业超市平台RDMS服务套餐购买合同.doc
                <label class="checkContract" @click="downLoadContract">下载</label>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 备注信息 -->
          <el-row style="margin-top:20px">
            <div>备注信息：</div>
            <el-input style="margin-top:20px"
                      type="textarea"
                      :maxlength="500"
                      :autosize="{ minRows: 4, maxRows: 8}"
                      placeholder="请输入备注信息："
                      v-model="dataForm.orderRemarks">
            </el-input>
          </el-row>
        </el-form>
        <div class="user-row center-content"
             style="text-align:center;margin-top:20px">
          <el-radio v-model="sureFlag"
                    class="sure-radio"
                    :label="true"
                    style="line-height: 26px;"
                    aria-checked="true">客户核对订单和合同的确认即意味已阅读并同意合同所有条款。关于合同解释权归我司所有</el-radio>
          <el-button class="save-but"
                  :loading="buttonLoading"
                  :disabled="!sureFlag"
                  type="primary"
                  @click="submit">提交订单</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// getDictDataList
// import { openOther } from '@/utils'
// import { isEmail } from '@/utils/validate'
// import qs from 'qs'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      buttonLoading: false, // 加载中
      // 生成订单参数
      params: {
        orderSource: '',
        shoppingCart: {}
      },
      // 生成订单返回参数
      dataJson: null,
      // 表单提交参数
      dataForm: {
        leaveMsg: '', // 改价留言
        contractType: '20', // 合同类型(10 自定义合同,20 默认合同,30 无需合同)
        orderRemarks: '', // 订单备注
        revisionPrice: false,
        fullAmount: true // 是否全款，false否，true是
      },
      sureFlag: false
    }
  },
  computed: {
  },
  mounted () {
    this.params.gatewayId = ''
    this.params.orderSource = this.$route.query.orderSource
    this.params.shoppingCart = {
      goodsSpuId: this.$route.query.goodSpuId || '',
      goodsSkuId: this.$route.query.goodSkuId || '',
      goodsNum: this.$route.query.goodsNum || 1
    }
    if (this.params.orderSource === '80') {
      // 自助
      this.params.gatewayId = this.$route.query.gatewayId || ''
      this.params.active = !!(Number(this.$route.query.active) || 0)
      this.params.startAt = this.$route.query.endAt || ''
    }
    this.getOrderInfo()
  },
  methods: {
    // 获取订单详情
    getOrderInfo () {
      this.dataJson = null
      this.$http.post(`/front/consumer/order/generateOrder`, this.params)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.dataJson = res.data
        })
    },
    // 提交订单
    submit () {
      if (this.buttonLoading) {
        return false
      }
      this.buttonLoading = true
      this.$http.post(`/front/consumer/order/saveOrder`, {
        ...this.params,
        ...this.dataForm
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          } else {
            this.$message.success('下单成功')
            this.$router.replace({
              name: 'rdmsOrderDetail',
              params: {
                id: res.data
              }
            })
          }
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    // 合同下载
    downLoadContract () {
      let url = window.SITE_CONFIG['apiURL'] + '/front/consumer/fictitiousorder/downLoadContract?commodityName=' +
                this.dataJson.payOrderItemVoList[0].goodsName +
                '&brandName=' + this.dataJson.payOrderItemVoList[0].brandName +
                '&model=' + this.dataJson.payOrderItemVoList[0].goodsModel +
                '&goodsPrice=' + this.dataJson.payOrderItemVoList[0].goodsPrice +
                '&goodsNum=' + this.dataJson.payOrderItemVoList[0].goodsNum +
                '&goodsMoney=' + this.dataJson.payOrderItemVoList[0].money +
                '&userId=' + Cookies.get('userId')
      window.open(url)
    }
  }
}
</script>
<style lang='scss' scoped>
.create_order{
  background: #fff;
  padding: 30px;
  .order_body{
    width: 907px;
    margin: 0 auto;
    .margin-top{
      margin-top: 20px;
    }
    .left-margin{
      margin-left: 30px;
    }
    /deep/ input[type="radio" ] {
      width: 14px;
      height: 14px;
      background: #fff;
      -webkit-appearance: none;
      -moz-appearance: none;
      border: 1px solid #dcdfe6;
      margin-right:10px;
      cursor:pointer;
    }
    .addBut{
      display: inline-block;
      width: 130px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid #1d65a8;
      color: #1d65a8;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      user-select: none;
      cursor: pointer;
      z-index: 666;
    }
    .addressList_oreder{
      padding-top: 20px;
      .addTitle {
        width: 906px;
        height: 40px;
        display: flex;
        .addTitle1 {
          flex: 1;
          font-size: 16px;
          color: #666666;
          line-height: 44px;
        }
        .addTitle2 {
          width: 130px;
          height: 40px;
          box-sizing: border-box;
          border: 1px solid #1d65a8;
          color: #1d65a8;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          user-select: none;
          cursor: pointer;
          z-index: 666;
        }
      }
    }
    // .downloadContract{
    //   padding-left: 80px;
    //   margin-top: 15px;
      .checkContract {
        margin-left: 20px;
        height: 36px;
        line-height: 36px;
        color: #1d65a8;
        cursor: pointer;
      }
    // }
    .discount {
      text-decoration: line-through;
      color: #aaaaaa;
    }
    .not-in-distribution{
      width: 320px;
      padding: 9px 43px;
      line-height: 22px;
      border: none;
      color: #fff;
      margin: 0 auto;
      cursor: not-allowed;
      background: #eee;
      color: #999;
    }
    .save-but{
      // background: #1d65a8;
      width: 320px;
      padding: 9px 43px;
      line-height: 22px;
      border: none;
      // color: #fff;
      margin: 0 auto;
      // cursor: pointer;
    }
    .deliveryArea{
      display: inline-block;
      border: 1px solid red;
      padding: 3px 5px;
      border-radius: 10px;
      color: red;
    }
    .default-flag{
      display: inline-block;
      width: 35px;
      height: 20px;
      line-height: 20px;
      background: #1d65a8;
      color: #ffffff;
      font-weight: normal;
      font-size: 12px;
      text-align: center;
      margin-left: 20px;
    }
  }
  .last_row{
    display: flex;
    justify-content: space-between;
    font-size: 20px;
  }
}
.addArea {
  width: 1100px;
  // height: 506px;
  background: #ffffff;
  padding-left: 23px;
  padding-right: 42px;
  .addTitle {
    height: 80px;
    line-height: 80px;
    font-size: 22px;
    color: #333333;
    text-indent: 8px;
    border-bottom: 1px solid #eeeeee;
  }
  .add_form{
    .input_width{
      width: 250px;
    }
    .last_row{
      display: flex;
      justify-content: space-between;
    }
    .saveAdd{
      width: 150px;
      height: 40px;
      background: #1D65A8;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin-top: 30px;
      margin-left: 859px;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }
}
</style>
